import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ArrowLeft, Home, AlertCircle } from 'lucide-react';
import { Button } from '../../ui/button';
import bunny1 from '../../../backgroundImages/bunny1.webp';

const ErrorScreen = ({ 
  children, 
  imageSrc = bunny1, 
  altText = "A cute bunny looking sad and confused" 
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <motion.div 
      className="min-h-screen bg-background flex flex-col items-center justify-center px-4 py-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="max-w-md w-full text-center space-y-6">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.1, type: "spring", stiffness: 200 }}
        >
          {imageSrc ? (
            <img
              src={imageSrc}
              alt={altText}
              className="w-32 h-32 sm:w-40 sm:h-40 mx-auto rounded-full object-cover shadow-lg border-4 border-white"
            />
          ) : (
            <div className="w-20 h-20 mx-auto bg-red-100 rounded-full flex items-center justify-center">
              <AlertCircle className="w-10 h-10 text-red-500" />
            </div>
          )}
        </motion.div>

        <motion.h1 
          className="text-2xl sm:text-3xl font-bold text-foreground"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          {t("error_uh_oh", "Uh oh!")}
        </motion.h1>

        {children && (
          <motion.div 
            className="text-base sm:text-lg text-muted-foreground leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            {children}
          </motion.div>
        )}

        <motion.div 
          className="flex flex-col sm:flex-row gap-3 justify-center pt-4"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="h-11 px-6"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t("back", "Go Back")}
          </Button>
          <Button
            onClick={() => navigate('/')}
            className="h-11 px-6"
          >
            <Home className="w-4 h-4 mr-2" />
            {t("home", "Home")}
          </Button>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ErrorScreen;
